import axios from "axios";

const axiosInstance = axios.create({
  //baseURL: "http://localhost:5000/", // Your base URL
   baseURL: "https://www.contacttab.com/",
 // baseURL: "https://contacttab.bbstechsolution.com/",
  timeout: 5000, // Timeout duration in milliseconds
  // You can add other configuration options here
});

export default axiosInstance;
